import { Autocomplete, Button, Input } from "@fullscreendigital/carrefour-dex-fe"
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { useFormik } from 'formik'
import { extractShopCode, getValidationSchema } from "./helpers"
import { useMutation } from 'react-query'
import { useNotification } from 'hooks'
import { handleQueryError } from 'utils/helpers'
import { FormInfoItems } from 'components/core-ui/FormInfoItems'
import { makeCorePostRequest } from 'utils/api'
import React, { useEffect, useMemo } from "react"
import { getDsSupplierList } from "../../../api";

const EditBalancePackaging = ({ isModalOpen, closeModal, editItem, supportTypeOptions, shopOptions, mode, setShouldRefreshData }) => {
  const { showNotification } = useNotification()

  const { data: supplierList } = getDsSupplierList(showNotification)

  const mutateStock = async values =>
    await makeCorePostRequest(`/shop-reception/ds-support-stock-inventory`, values)

  const { isLoading, mutate } = useMutation(mutateStock, {
    onSuccess: () => {
      setShouldRefreshData(true)
      closeModal()
      formik.resetForm()
      showNotification({
        message: mode === 'add' ? 'Soldul a fost adăugat cu succes.' : 'Soldul a fost actualizat cu succes.',
        type: 'success'
      })
    },
    onError: error =>
      handleQueryError(error, 'A aparut o eroare la actualizarea soldului.', showNotification)
  })

  const initialValues = useMemo(() => ({
    supplierCode: mode === 'edit' ? editItem?.supplierCode ?? '' : '',
    shopCode:     mode === 'edit' ? editItem?.shopCode ?? ''     : '',
    dsSupportTypeId: mode === 'edit' ? (editItem?.supportId ?? '') : '',
    stock:        mode === 'edit' ? (editItem?.stock ?? '')      : ''
  }), [mode, editItem])

  useEffect(() => {
    if (!isModalOpen) {
      formik.resetForm()
    }
  }, [isModalOpen])

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues,
    validationSchema: getValidationSchema(mode),
    onSubmit: async (values: any) => {
      const payload = {
        supplierCode: Number(values.supplierCode),
        shopCode: extractShopCode(values.shopCode),
        dsSupportTypeId: values.dsSupportTypeId,
        stock: Number(values.stock)
      }
      mutate(payload)
    }
  })

  const isEdit = mode === 'edit'

  return (
    <Modal isModalOpen={isModalOpen} closeModal={closeModal} modalTitle={isEdit ? "Actualizare sold" : "Adaugă sold suport"}>
      <Grid container spacing={4}>
        {isEdit ? (
            <Grid xs={12} item>
              <FormInfoItems
                items={[
                  editItem?.shopCode && { label: 'Magazin:', name: editItem?.shopCode },
                  editItem?.supplierName && { label: 'Furnizor:', name: editItem?.supplierName },
                  { label: 'Suport:', name: editItem?.supportName }
                ]}
              />
            </Grid>
        ) : (
          <>
            <Grid xs={12} item>
              <Autocomplete
                variant="outlined"
                label="Magazin"
                disableClearable
                required
                onChange={(_, opt) => formik.setFieldValue('shopCode', opt?.value ?? '')}
                value={(shopOptions || []).find(o => o.value === formik.values.shopCode) || null}
                options={shopOptions || []}
                getOptionLabel={(o) => o?.label ?? ''}
                error={!!formik.errors.shopCode}
                helperText={formik.errors.shopCode as string}
              />
            </Grid>
            <Grid xs={12} item>
              <Autocomplete
                variant="outlined"
                label="Cod furnizor"
                disableClearable
                required
                onChange={(_, opt) => formik.setFieldValue('supplierCode', opt?.value ?? '')}
                value={(supplierList || []).find(o => o.value === formik.values.supplierCode) || null}
                options={supplierList || []}
                getOptionLabel={(o) => o?.label ?? ''}
                error={!!formik.errors.supplierCode}
                helperText={formik.errors.supplierCode as string}
              />
            </Grid>
            <Grid xs={12} item>
              <Autocomplete
                variant="outlined"
                label="Tip suport"
                disableClearable
                required
                onChange={(_, opt) => formik.setFieldValue('dsSupportTypeId', opt?.value ?? '')}
                value={(supportTypeOptions || []).find(o => o.value === formik.values.dsSupportTypeId) || null}
                options={supportTypeOptions || []}
                error={!!formik.errors.dsSupportTypeId}
                helperText={formik.errors.dsSupportTypeId as string}
              />
            </Grid>
          </>
        )}

        <Grid xs={12} item>
          <Input
            type="number"
            name="stock"
            label="Sold"
            fullWidth
            variant="outlined"
            value={formik.values.stock}
            onChange={event => formik.setFieldValue('stock', event.currentTarget.value)}
            error={!!formik.errors.stock}
            helperText={formik.errors.stock as string}
            required
          />
        </Grid>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={() => closeModal()} />
          <Button
            variant="contained"
            label={isEdit ? 'Salveaza' : 'Adauga'}
            onClick={() => formik.handleSubmit()}
            disabled={isLoading}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default EditBalancePackaging
